import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
//UI
import {
  DangerButton,
  SuccessButton,
  PrimaryButton,
  WarningButton,
} from "../../../../ui/buttons/Button";
import useTable from "../../../../components/useTable";
const headCells = [
  {
    id: "anio",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Año",
    textAlign: "center",
  },
  {
    id: "fecha",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Fecha",
    textAlign: "center",
  },
  {
    id: "valor",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Valor",
    textAlign: "center",
  },
];

export default function ValorUnidadTributaria({ show, setShow, setTabla }) {
  const [tableData, setTableData] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, recordsAfterPagingAndSorting } = useTable(
    tableData,
    headCells,
    filterFn
  );

  const salir = () => {
    setShow(false);
    setTabla(0);
  };

  return (
    <Modal size="lg" show={show} centered backdrop="static" keyboard={false}>
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">Unidad Tributaria</h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-2 d-flex">
        <div className="col-11 m-0 p-0">
          <TblContainer>
            <TblHead />
            <tbody>
              {tableData &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr key={index}></tr>
                ))}
            </tbody>
          </TblContainer>
        </div>
        <div className="col-1 m-0 p-0 d-flex flex-column gap-2 align-items-center justify-content-center">
          <div className="col-auto m-0 p-0">
            <PrimaryButton icon="fa-plus m-0" />
          </div>
          <div className="col-auto m-0 p-0">
            <WarningButton icon="fa-edit m-0" />
          </div>
          <div className="col-auto m-0 p-0">
            <DangerButton icon="fa-trash-alt m-0" />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton>Aceptar</SuccessButton>
        <DangerButton>Cancelar</DangerButton>
      </Modal.Footer>
    </Modal>
  );
}
